import { styled } from '@arpeggi/ui'
import InfiniteScrollComponent from 'react-infinite-scroll-component'

export const StyledInfiniteScroll = styled(InfiniteScrollComponent, {})
